import AcceptClaim from './AcceptClaim';
export default AcceptClaim;
